import { render, staticRenderFns } from "./ImportModal.vue?vue&type=template&id=638febb0&"
import script from "./ImportModal.vue?vue&type=script&lang=ts&"
export * from "./ImportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports